import Main from "./sections/Main";
import Projects from "./sections/Projects";

export default function HomePage() {
    return <>
        <Main />
        <Projects />
    </>
}